export const getters = {
  getEntradaMercadoria: (state) => state.entradaMercadoria,
  getEntradasMercadorias: (state) => state.entradasMercadorias,
  getModalCadastroEntradaMercadoria: (state) => state.modalCadastrarEntradaMercadoria,
  getItensEntradaMercadoria: (state) => state.itensEntradaMercadoria,
  getModalExcluirEntradaMercadoria: (state) => state.modalExcluirEntradaMercadoria,
  getModalPesquisarEntradaMercadoria: (state) => state.modalPesquisarEntradaMercadoria,
  getModalEnviarEmailEntradaMercadoria: (state) => state.modalEnviarEmailEntradaMercadoria,
  getContasPagarEntradaMercadoria: (state) => state.contasPagarEntradaMercadoria,
};

export default {};
